import Vue from 'vue';
import VJsf from '@koumoul/vjsf/lib/VJsf.js'
import '@koumoul/vjsf/lib/deps/third-party.js'


Vue.component("VJsf", VJsf)
